import styles from './table.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children?: React.ReactNode;
    columns?: number;
}

export function TableRow({children, columns}: OwnProps) {
    return (
        <div
            className={classNames(styles.table__row, {
                [styles.columns_one]: columns === 1,
                [styles.columns_two]: columns === 2,
                [styles.columns_three]: columns === 3,
            })}
        >
            {children}
        </div>
    );
}
